import './Footer.css';

// Shown on every page (agreed in the 2 Oct product meeting).
export default function Footer() {
  return (
    <footer className="footer">
      <p>
        For educational purposes only. Capital at risk. Members share their own portfolios for
        discussion and learning. Nothing here is financial advice or a recommendation.
      </p>
    </footer>
  );
}
